import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit-button',
  template: `
    <button
      type="button"
      class="app-edit-button"
      [class.app-edit-button--with-icon]="showIcon"
      [ngClass]="customClass"
      [disabled]="disabled"
      (click)="handleClick($event)"
    >
      <svg
        *ngIf="showIcon"
        class="app-edit-button__icon"
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M7.33398 2.66663H2.66732C2.3137 2.66663 1.97456 2.8071 1.72451 3.05715C1.47446 3.3072 1.33398 3.64634 1.33398 3.99996V13.3333C1.33398 13.6869 1.47446 14.0261 1.72451 14.2761C1.97456 14.5262 2.3137 14.6666 2.66732 14.6666H12.0007C12.3543 14.6666 12.6934 14.5262 12.9435 14.2761C13.1935 14.0261 13.334 13.6869 13.334 13.3333V8.66663"
        ></path>
        <path
          d="M12.334 1.66663C12.5992 1.40141 12.9588 1.25244 13.334 1.25244C13.7092 1.25244 14.0687 1.40141 14.334 1.66663C14.5992 1.93185 14.7482 2.29141 14.7482 2.66663C14.7482 3.04185 14.5992 3.40141 14.334 3.66663L7.99998 9.99996L5.33331 10.6666L5.99998 7.99996L12.334 1.66663Z"
        ></path>
      </svg>
      <span class="app-edit-button__label">{{ label }}</span>
    </button>
  `,
  styles: [`
    .app-edit-button {
      font-family: 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 6px !important;
      min-width: 140px !important;
      width: 140px !important;
      height: 38px !important;
      padding: 0 24px !important;
      border-radius: 6px !important;
      border: 1px solid #3197ff !important;
      background-color: #ffffff !important;
      color: #3197ff !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
      cursor: pointer !important;
      text-transform: none !important;
      outline: none !important;
      box-shadow: none !important;
      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;

      &:hover:not(:disabled) {
        background-color: #f0f7ff !important;
        border-color: #1b85f0 !important;
        color: #1b85f0 !important;
      }

      &:active:not(:disabled) {
        background-color: #e0effe !important;
        border-color: #1072d6 !important;
      }

      &:disabled {
        opacity: 0.5 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
      }

      &__icon {
        flex-shrink: 0;
      }

      &__label {
        color: inherit;
      }
    }
  `]
})
export class AppEditButtonComponent {
  @Input() label: string = 'Edit';
  @Input() disabled: boolean = false;
  @Input() showIcon: boolean = false;
  @Input() customClass: string = '';
  @Output() btnClick = new EventEmitter<MouseEvent>();
  @Output() click = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent): void {
    if (!this.disabled) {
      this.btnClick.emit(event);
      this.click.emit(event);
    }
  }
}
